import React, { Component } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LoadingCircular from "../LoadingCircular";
import CardMembershipIcon from "@mui/icons-material/CardMembership";

class GetCertificate extends Component {
  state = {
    isLoading: false,
    tracingCode: "",
  };
  onSubmit = async (e) => {
    e.preventDefault();
    if (this.state.mokhatab === "" || this.state.sharh === "") {
      alert("لطفا موارد ستاره دار را تکمیل نمایید");
      return;
    }
    //send to api
    this.setState({ isLoading: true });
    const response = await fetch(
      `/ng/api/Certificate/${this.state.tracingCode}`
    );
    this.setState({ isLoading: false });
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const data = await response.json();
      if (data.Msg === "404") alert("کد ردیابی وارد شده معتبر نمی باشد");
    } else if (contentType.indexOf("application/pdf") !== -1) {
      const blob = await response.blob();
      if (blob != null) {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = `negin-certificate-${this.state.tracingCode}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    }
  };
  render() {
    const { isLoading } = this.state;
    return (
      <Stack
        component="form"
        spacing={1.5}
        noValidate
        autoComplete="off"
        onSubmit={this.onSubmit}
      >
        <LoadingCircular open={isLoading} />
        <Typography variant="h6" sx={{ textAlign: "center" }}>
          <CardMembershipIcon /> دریافت گواهی انطباق محصول
        </Typography>
        <Typography variant="caption">
          جهت دریافت گواهی انطباق، مقدار Tracing Code چاپ شده بر روی لیبل
          محصولات را در کادر زیر وارد نمایید
        </Typography>

        <TextField
          label="Tracing Code"
          variant="standard"
          onChange={(e) => {
            this.setState({ tracingCode: e.target.value });
          }}
        />
        <Button type="submit" variant="contained">
          دریافت
        </Button>
      </Stack>
    );
  }
}

export default GetCertificate;
